<template>
    <QDialog
        v-model="open"
        @hide="closeModal"
    >
        <QCard class="MoveModal">
            <QBar class="bg-primary text-white">
                <div class="text-subtitle1 text-weight-medium">
                    {{ $t('projects.datasets.moveDataset') }}
                </div>
                <QSpace />
                <QBtn
                    v-close-popup
                    dense
                    flat
                    color="white"
                    icon="close"
                    @click="closeModal"
                />
            </QBar>
            <q-card-section>
                <QTabs
                    v-model="sharedTab"
                    activeColor="primary"
                    indicatorColor="primary"
                    noCaps
                    @update:modelValue="toggleShared"
                >
                    <QTab
                        name="my_organizations"
                        :label="$t('projects.datasets.createdByMe')"
                    />
                    <QTab
                        name="shared_organizations"
                        :label="$t('projects.datasets.sharedWithMe')"
                    />
                </QTabs>
                <div class="q-mt-sm organizations-scroll">
                    <div
                        v-for="organization in organizations"
                        :key="organization.uuid"
                        class="organization-item"
                    >
                        <QItem
                            clickable
                            @click="loadProjects(organization)"
                        >
                            <QItemSection avatar>
                                <QIcon name="folder" />
                            </QItemSection>
                            <QItemSection>{{ organization.name }}</QItemSection>
                        </QItem>
                        <div
                            v-if="selectedOrganization && selectedOrganization.uuid === organization.uuid"
                            class="projects-list"
                        >
                            <div
                                v-for="project in projects"
                                :key="project.uuid"
                                class="project-item"
                            >
                                <QItem
                                    clickable
                                    :class="{ 'selected-project': selectedProject && selectedProject.uuid === project.uuid }"
                                    @click="selectProject(project)"
                                >
                                    <QItemSection avatar>
                                        <QIcon name="folder_open" />
                                    </QItemSection>
                                    <QItemSection>{{ project.name }}</QItemSection>
                                    <QItemSection avatar>
                                        <QIcon
                                            :name="selectedProject && selectedProject.uuid === project.uuid ? 'check_box' : 'check_box_outline_blank'"
                                            color="primary"
                                        />
                                    </QItemSection>
                                </QItem>
                            </div>
                        </div>
                    </div>
                </div>
                <QForm
                    class="align-center q-gutter-md q-my-md"
                    @submit.prevent="moveDataset"
                >
                    <div class="justify-end row q-my-lg">
                        <QBtn
                            noCaps
                            color="primary"
                            outline
                            type="submit"
                            :label="$t('projects.datasets.move')"
                        />
                    </div>
                </QForm>
            </q-card-section>
        </QCard>
    </QDialog>
</template>
<script>
import VueTypes from 'vue-types'

import {
    apiRequest, Api, notifyError, notifySuccess, notify,
} from '@/api'

export default {
    name: 'MoveDatasetModal',
    components: {},
    props: {
        isOpen: VueTypes.bool.def(false),
        dataset: VueTypes.object.isRequired,
        currentProjectId: VueTypes.string.isRequired,
    },
    emits: ['close', 'move'],
    data() {
        return {
            organizations: [],
            groups: [],
            open: false,
            projects: [],
            datasets: [],
            selectedOrganization: null,
            selectedProject: null,
            selectedDataset: null,
            shared: false,
            sharedTab: 'my_organizations',
        }
    },
    watch: {
        isOpen(open) {
            this.open = open
            this.loadOrganizations()
        },
    },
    created() {
        this.loadOrganizations()
        this.open = this.isOpen
    },
    methods: {
        toggleShared(tabName) {
            this.shared = tabName === 'shared_organizations'
            this.loadOrganizations()
        },
        async loadOrganizations() {
            try {
                const params = {
                    shared: this.shared,
                }
                const { data } = await apiRequest(Api().organizations.list(params))
                this.organizations = data
            } catch (error) {
                notifyError(error)
            }
        },
        async loadProjects(organization) {
            this.selectedOrganization = organization
            this.projects = []
            if (this.selectedOrganization) {
                try {
                    const params = {
                        organizationUid: this.selectedOrganization.uuid,
                    }
                    const { data } = await apiRequest(Api().projects.list(params))
                    this.projects = data
                    this.datasets = []
                } catch (error) {
                    notifyError(error)
                }
            }
        },
        async loadDatasets() {
            if (this.selectedProject) {
                try {
                    const params = {
                        projectUid: this.selectedProject.uuid,
                    }
                    const { data } = await apiRequest(Api().datasets.list(params))
                    this.datasets = data
                } catch (error) {
                    notifyError(error)
                }
            }
        },
        selectProject(project) {
            this.selectedProject = project
        },
        async moveDataset() {
            if (!this.dataset || !this.dataset.uuid || !this.selectedProject) {
                notify({ message: this.$t('projects.datasets.missingData') })
                return
            }
            if (this.selectedProject.uuid === this.currentProjectId) {
                notify({ message: this.$t('projects.datasets.sameProjectError') })
                return
            }
            const params = {
                datasetId: this.dataset.uuid,
                targetProjectId: this.selectedProject.uuid,
            }
            try {
                await apiRequest(Api().datasets.move(params))
                notifySuccess(this.$t('projects.datasets.moveSuccess'))

                this.$emit('moved')
            } catch (error) {
                notifyError(error)
            }
        },
        closeModal() {
            this.$emit('close')
        },
    },
}
</script>
<style scoped lang="scss">
.MoveModal {
    min-width: 450px;
    max-width: 500px;
    max-height: 640px;

}
.organizations-scroll {
    max-height: 400px;
    overflow-y: auto;
}
</style>
